/*eslint-disable */

import {bus} from '@/main';
import headerAfterLogin from '../header-after-login/index';
import headerBeforeLogin from '../header-before-login/index';
import {
  mapGetters
} from 'vuex';

export default {
  name: 'app_header',
  components: {
    'header-before-login': headerBeforeLogin,
    'header-after-login': headerAfterLogin
  },
  props: [],
  data () {
    return {
      isLoggedIn: ''
    }
  },
  computed:{
    checkUserLogin() {
      return this.isLoggedIn = this.$store.getters.isAuthenticated
    }
  },

  mounted () {
  },
  methods: {

  },
  updated(){

  },
  created(){
  },
  watch: {
    checkUserLogin() {
      return this.$store.getters.isAuthenticated
    }
  }
}
